import { useContext } from 'react'
import { useQuery } from 'react-query'
import { domoscioAccess } from '../api/domoscio_access'
import { ObjectiveStudent } from '../types/hub/objective'
import { LearningSession } from '../types/hub/learningSession'
import { ObjectivesFilterContext } from '../contexts/parameters/filterContext'
import { useRiseUpClient } from './useRiseUpClient'
import { lxpHubTypes } from '@domoscio/domoscio-sdk-js'
import { useObjectiveKnowledgeNode } from '../contexts/objectiveKnowledgeKnodes'
export const useFetchStudentLearningDatas = (
  studentUid: string | undefined,
  objectiveId: number[] | null
) => {
  const { objectiveFilters } = useContext(ObjectivesFilterContext)
  const { isRiseup } = useRiseUpClient()

  const { okns } = useObjectiveKnowledgeNode()
  const body = { student_uid: studentUid } as any

  const lpsObjectives = objectiveFilters.objectivesOfSelectedExp
  // filtered by theme
  if (objectiveId) {
    body.objective_id = objectiveId
  }
  const { data: objectivesStudent } = useQuery(
    ['ObjectiveStudents', body],
    async (): Promise<ObjectiveStudent[]> => {
      return domoscioAccess.getObjectiveStudents(body)
    },
    {
      enabled: studentUid !== undefined && !isRiseup // for riseup, we get objective from objectiveKnowledgeNodes
    }
  )
  if (objectivesStudent) {
    body.objective_student_id = objectivesStudent.map(os => os.id)
  }
  const isEnabled = objectivesStudent !== undefined && objectivesStudent.length > 0
  const { data: learningSessions, status: lsFetchStatus } = useQuery(
    ['LsOfStudents', body],
    async (): Promise<LearningSession[]> => {
      return domoscioAccess.getLearningSessions(body)
    },
    {
      enabled: isEnabled || isRiseup // for riseup, we get enabled from objectiveKnowledgeNodes
    }
  )

  const isLoading = lsFetchStatus === 'loading' || lsFetchStatus === 'idle'

  const assigneObjectiveInfos = (objectivesStudent: ObjectiveStudent[]) => {
    // for riseup, we create a objective student list with the objective and the kns
    if (isRiseup) {
      const objectiveRu: Partial<lxpHubTypes.Objective> = {
        ...okns[0].objective,
        attempt_options: {
          workflow: 'attempt_after_recommendations'
        }
      }
      return [
        {
          objective_id: okns[0].objective_id,
          objective: objectiveRu,
          name: undefined,
          learning_sessions: learningSessions,
          objective_knowledge_nodes: okns,
          student_id: learningSessions?.[0]?.student_id
        }
      ]
    } else {
      return objectivesStudent
        .map(os => {
          const obj = lpsObjectives.find(objective => objective.id === os.objective_id)
          const lsOfObjective = learningSessions?.filter(ls => ls.objective_id === obj?.id)

          const knsOfObjective = okns.filter(kn => kn.objective_id === obj?.id)
          return {
            ...os,
            objective: obj,
            name: obj?.name,
            image_url: obj?.image_url,
            learning_program_id: obj?.learning_program_id,
            learning_sessions: lsOfObjective,
            objective_knowledge_nodes: knsOfObjective
          }
        })
        .filter(el => el.objective)
    }
  }

  return {
    objectivesStudent: assigneObjectiveInfos(objectivesStudent || []),
    learningSessions,
    isLoading
  }
}
